import React, {Component} from 'react';
import {PropTypes} from 'prop-types';
import { connect } from 'react-redux';
import DashboardAppSection from "../DashboardAppSection";
import DashboardButton from "../button/DashboardButton";
import HrbTranslate from "../../language/HrbTranslate";
import VirtualAssistCaseButton from "./VirtualAssistCaseButton";
import {getConfiguration} from "../../../store/rootReducer";
import vaDashBoardErrorImg from '../../../resources/images/va-dash-error.png';
import ActionLink from "../../link/ActionLink";
import vaImage from '../../../resources/images/va_head.png'
import './VirtualAssistDashboardSection.scss'
import auth from '../../../services/auth/AuthProvider';

class VirtualAssistDashboardSection extends Component {

  openVirtualAssistCase = () => {
    auth.redirect('RTE', 'login');
  };

  getCaseButtonItems = () => {
    let casesObject = this.props.virtualAssistCases;
    
    if (!casesObject || !casesObject.cases || casesObject.cases.length === 0) {
      return (
          <DashboardButton onClick={this.openVirtualAssistCase}>
            <div className="va-dashboard-single-item">
              <HrbTranslate text="dashboard.va_start_return"/>
            </div>
          </DashboardButton>
      );
    }

    let caseButtonItems = casesObject.cases.map((item) => {
      return <VirtualAssistCaseButton key={item.id} caseItem={item}/>;
    });

    /*
      // For now VA only supports a single case so show either the start new 
      // or the open case button, not both (VCP-159)
      caseButtonItems.push(
        <DashboardButton key={"startReturnKey"} onClick={this.openVirtualAssistCase}>
          <HrbTranslate text="dashboard.va_start_return"/>
        </DashboardButton>
    );*/

    return caseButtonItems;
  };

  getVADashboardErrorContent = () => {
      return (
          <div className="hrb-va-dashboard-error-container">
              <img className="hrb-va-dashboard-error-img" src={vaDashBoardErrorImg} alt="vaConnectionErrorImg"/>

              <HrbTranslate text="dashboard.va_tax_expert_error_paragraph_one"/>

              <HrbTranslate text="dashboard.va_tax_expert_error_paragraph_two_line1"/>
              <div className="hrb-va-dashboard-error-container-refresh-text">
                  <ActionLink text="dashboard.va_tax_expert_error_paragraph_two_line2" onClick={this.refreshCurrentPage}/>
              </div>
              <HrbTranslate text="dashboard.va_tax_expert_error_paragraph_two_line3"/>
          </div>
      )
  };

  refreshCurrentPage = () => {
      window.location.reload();
  };

    render() {
        let hasError = false;
        if (this.props.virtualAssistCases && this.props.virtualAssistCases.status)
            hasError = this.props.virtualAssistCases.status === 'ERROR';

        let img = (
            <div className="hrb-va-dashboard-img-container"><img src={vaImage} width="42px" height="42px" alt=''/></div>
        )
        return this.props.virtualAssistCases && this.props.virtualAssistCases.isUnavailable
            ? null :
            (
                <div className="va-dashboard-section">
                    <DashboardAppSection header="dashboard.va_tax_expert_heading" sectionHelpLink="links.virtual_assist" img={img}>
                        { hasError && this.getVADashboardErrorContent()}
                        {!hasError && this.getCaseButtonItems()}
                    </DashboardAppSection>
                </div>
            );
        }
    }

VirtualAssistDashboardSection.propTypes = {
  virtualAssistCases: PropTypes.object
};

const mapStateToProps = (state) => {
  return {
    configuration: getConfiguration(state)
  }
};

export default connect(
    mapStateToProps,
)(VirtualAssistDashboardSection);